import { render, staticRenderFns } from "./notice-component.vue?vue&type=template&id=470bd7e4&scoped=true&"
import script from "./notice-component.vue?vue&type=script&lang=js&"
export * from "./notice-component.vue?vue&type=script&lang=js&"
import style0 from "./notice-component.vue?vue&type=style&index=0&id=470bd7e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470bd7e4",
  null
  
)

export default component.exports